module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    directives: [{
      name: "wechat-title",
      rawName: "v-wechat-title",
      value: (_vm.$route.meta.title),
      expression: "$route.meta.title"
    }]
  }), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.meta.tabBar),
      expression: "this.$route.meta.tabBar"
    }],
    staticClass: "bar tabbar"
  }, [_c('a', {
    staticClass: "tab-index router",
    class: {
      active: this.$route.meta.home
    },
    on: {
      "click": function($event) {
        _vm.changeTab('home')
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('a', {
    staticClass: "tab-my router",
    class: {
      active: this.$route.meta.my
    },
    on: {
      "click": function($event) {
        _vm.changeTab('my')
      }
    }
  }, [_vm._v("我的")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0fa09474!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 600
// module chunks = 17